import { render } from "./linkWikipediaView.vue?vue&type=template&id=4d72e7a4"
import script from "./linkWikipediaView.vue?vue&type=script&lang=js"
export * from "./linkWikipediaView.vue?vue&type=script&lang=js"

import "./linkWikipediaView.vue?vue&type=style&index=0&id=4d72e7a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__